<script>
 import 'whatwg-fetch'
 import 'promise-polyfill/src/polyfill'
 import { onMount } from 'svelte'
 import { get } from 'svelte/store'
 import { publications, cart_totals } from './store.js'

 let states = []
 let countries = []
 let counties = []
 let mills = []
 let qsups = []
 let salestax = 0
 let taxrate = 0
 let pretax = 0
 let total = 0
 let selected_country = 'US'
 let selected_state = ''
 let selected_county = ''
 let discount = 0

 let isSubscriber = false
 let isNonprofit = false

 onMount(async function() {
   const response = await fetch('/api/v1/forms/options')
   const data = await response.json()
   states = data.states
   countries = data.countries
   counties = data.counties
   mills = data.mills
   qsups = data.qs
 })

 $: {
   if ( isSubscriber ) {
     discount = Number(prediscount) * 0.3333
     pretax = Number(prediscount) - discount
   } else {
     discount = 0
     pretax = Number(prediscount)
   }

   if ( selected_county ) {
     let taxrate_arr = counties.filter(function(c) { return c.county === selected_county })

     if ( isNonprofit ) {
       taxrate = 0
     } else if ( taxrate_arr.length ) {
       taxrate = Number(taxrate_arr[0]["salestax"])
     } else {
       taxrate = 0
     }
   } else {
     taxrate = 0
   }

   if ( selected_state == 'FL' && selected_country == 'US' ) {
     salestax = pretax * ( taxrate / 100 )
   } else {
     salestax = 0
   }

   total = pretax + salestax
 }

 $: prediscount = $publications.reduce(function(t,p) {
   return t + ( p.quantity * p.price )
 }, 0)

 function removeFromCart(pubs, i) {
   updateQuantity(pubs, i, 0)
 }

 function updateQuantity(pubs, i, val) {
   val = parseInt(val)

   if ( isNaN(val) ) {
     return
   }

   if ( val < 0 ) {
     val = 0
   }

   pubs[i].quantity = val
   publications.set(pubs)
   resetCartTotals()
 }

 function resetCartTotals() {
   cart_totals.set(0)

   $publications.forEach(function(pub) {
     cart_totals.update(function(n) { return Number(n) + Number(pub.quantity) })
   })
 }
</script>

<svelte:head>
</svelte:head>

{#if $cart_totals}

  <form class="webform" id="litform" action="/resources/publications-payment" method="POST">

    <div class="shopping-cart">
      <table>
        <tr>
          <th>Item</th>
          <th>Unit Price</th>
          <th>Quantity</th>
          <th>Total</th>
          <th>Remove</th>
        </tr>
        {#each $publications as pub, i}
          {#if pub.quantity > 0}
            <tr>
              <td>{pub.name}</td>
              <td>${pub.price}</td>
              <td>
                <input on:input={function(event) {updateQuantity($publications, i, event.target.value) }}
                                name="{pub.id}" type="number" value="{pub.quantity}"
                />
              </td>
              <td>${pub.price * pub.quantity}</td>
              <td>
                <button class="button delete" on:click={function() { removeFromCart($publications, i) }}>
                  Remove
                </button>
              </td>
            </tr>
          {/if}
        {/each}
        <tr>
          <th colspan="3" style="text-align:right">Subtotal (Before Taxes and Discount):</th>
          <td>${ prediscount }</td>
        </tr>
      </table>
    </div>


    <h3 class="special">Contact Information</h3>
    <label>Name</label>
    <input id="name" name="name" type="text" placeholder="Primary Contact" required />
    <label>Business Name</label>
    <input id="business" name="business" type="text" placeholder="Name of Business" required />
    <label>Phone</label>
    <input id="tel" name="tel" type="tel" required />
    <label>Email</label>
    <input id="email" name="email" type="email" required />
    <label><strong>Tax Exempt Status</strong></label>
    <input bind:checked={isNonprofit} name="nonprofit" id="nonprofit" type="checkbox" value="true" /> <i>I am ordering on behalf of a tax-exempt organization operating in the state of Florida</i> <br><br>

    {#if isNonprofit}
      <div class="nonprofit-info">
        <label>Tax Exempt ID</label>
        <input name="nonprofit_id" type="text" />
      </div>
    {/if}
    <hr>
    <h3 class="special">Subscriber Information</h3>
    <p>
      <label><strong>Are you an SPIB subscriber?</strong></label>
      <input bind:checked={isSubscriber} id="isSubscriber" name="isSubscriber" type="checkbox" value="true" />
      I am a subscriber
    </p>
    {#if isSubscriber}
      <p class="subscriber-info">
        <label>Select Mill</label>
        <select id="mill" name="mill">
          <option value=""></option>
          {#each mills as mill}
            <option value="{mill.plantid}">{mill.full_name}</option>
          {/each}
        </select>
        <label>SPIB Quality Supervisor</label>
        <select id="qs" name="qs">
          <option value=""></option>
          {#each qsups as qs}
          <option value="{qs.id}">{qs.name}</option>
          {/each}
        </select>
      </p>
    {/if}
    <hr>
    <h3 class="special">Customer Shipping Information</h3>
    <label>Address</label>
    <input id="address1" name="address1" type="text" placeholder="Address Line 1" required />
    <input id="address2" name="address2" type="text" placeholder="Address Line 2" />
    <label>City</label>
    <input id="city" name="city" type="text" placeholder="Ex: Pensacola" required />
    <label for="state">State/Province</label>
    <select bind:value={selected_state} required="required" id="state" name="state">
      <option value=""></option>
      {#each states as state}
      <option value="{state.code}">{state.name}</option>
      {/each}
    </select>
    <label for="country">Country</label>
    <select bind:value={selected_country} id="country" name="country">
      {#each countries as country}
        <option value="{country.code}">{country.name}</option>
      {/each}
    </select>
    <label for="zip">Postal Code</label>
    <input id="zip" name="zip" type="text" required />
    <label for="county">County (Florida Only)</label>
    <select bind:value={selected_county}
            id="county"
            name="county"
            required={selected_state === 'FL'}
            >
      <option value=""></option>
      {#each counties as county}
        <option value="{county.county}">{county.county}</option>
      {/each}
    </select>
    <span><strong>Note:</strong>Florida Residents will be charged sales tax.</span>
    <hr>
    <h3 class="special">Order Summary</h3>
    <table>
      <tr>
        <td>Total Before Discount:</td>
        <td><span id="prediscount" class="prediscount" name="total">${prediscount}.00</span></td>
        <td></td>
      </tr>
      <tr>
        <td>Subscriber Discount (33.33%):</td>
        <td><span id="discount" class="discount">${discount.toFixed(2)}</span></td>
        <td></td>
      </tr>
      <tr>
        <td>Florida Sales Tax:</td>
        <td><span id="salestax" class="discount">${salestax.toFixed(2)}</span></td>
        <td></td>
      </tr>
      <tr>
        <td><strong>Total:</strong></td>
        <td><strong><span id="total" class="total" name="total">${total.toFixed(2)}</span></strong></td>
        <td></td>
      </tr>

    </table>
    <br>
    <div class="button-wrap">
      <input class="button" name="submit" value="Continue to Payment >>" type="submit" />
    </div>
  </form>


{:else}
  <p>You have no items in your shopping cart. <a href="/resources/publications-listing">
    Click here to find SPIB literature.</a></p>
{/if}



<style>
 table {
   width: 100%;
 }

 table td, table th {
   padding: 5px 10px
 }

 table th {
   background: #EFEFEF;
 }

 .button {
   transition-duration: 0.4s;
   border: none;
   padding: 15px 32px;
   text-align: center;
   text-decoration: none;
   display: inline-block;
   background-color: #1f5733;
   color: white;
 }

 .button:hover {
   background-color: #12311d;
 }

 .button.delete {
   background-color: rgb(235, 73, 29);
 }

 .button.delete:hover {
   background-color: rgb(180, 73, 29);
 }

</style>
